var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9453_135688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6304 10.0415L25.84 10.0415L21.2122 5.07434L21.2122 9.62335C21.2122 9.8543 21.3995 10.0415 21.6304 10.0415ZM21.6304 11.4354L26.4811 11.4354L26.4811 27.9557L9.89389 27.9557L9.89389 24.9996L8.5 24.9996L8.5 28.2345C8.5 28.8504 8.99926 29.3496 9.61511 29.3496L26.7599 29.3496C27.3757 29.3496 27.875 28.8504 27.875 28.2345L27.875 10.6199C27.875 10.4145 27.8183 10.2147 27.7133 10.0415C27.6741 9.97683 27.6281 9.91587 27.5758 9.85973L21.5151 3.35459C21.4271 3.26019 21.3245 3.18279 21.2122 3.12464C21.0553 3.04332 20.8796 2.99961 20.6992 2.99961L9.61511 2.99961C8.99926 2.99961 8.5 3.49886 8.5 4.11472L8.5 12.9996L9.89389 12.9996L9.89389 4.3935L19.8183 4.3935L19.8183 9.62335C19.8183 10.6241 20.6296 11.4354 21.6304 11.4354Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93402e-07 16C4.65826e-07 14.3431 1.34315 13 3 13L22 13C23.6569 13 25 14.3431 25 16L25 22C25 23.6569 23.6569 25 22 25L3 25C1.34315 25 5.87107e-08 23.6569 1.31134e-07 22L3.93402e-07 16ZM22.9 16.1179L20.8755 19.1632L22.8914 22.2L21.6562 22.2L20.2407 19.9782L18.8082 22.2L17.5986 22.2L19.6317 19.1547L17.6158 16.1179L18.851 16.1179L20.2665 18.3483L21.6905 16.1179L22.9 16.1179ZM15.3234 17.0873L17.3049 17.0873L17.3049 16.1179L12.3209 16.1179L12.3209 17.0873L14.294 17.0873L14.294 22.2L15.3234 22.2L15.3234 17.0873ZM11.9268 17.0873L9.94516 17.0873L9.94516 22.2L8.91577 22.2L8.91577 17.0873L6.94276 17.0873L6.94276 16.1179L11.9268 16.1179L11.9268 17.0873ZM4.5017 18.9145L3.42942 18.9145L3.42942 17.0272L4.5017 17.0272C5.15365 17.0272 5.54826 17.3961 5.54826 17.9794C5.54826 18.5542 5.15365 18.9145 4.5017 18.9145ZM3.42941 19.8238L4.65611 19.8238C5.82276 19.8238 6.59481 19.0431 6.59481 17.9709C6.59481 16.9071 5.82276 16.1179 4.65611 16.1179L2.40002 16.1179L2.40002 22.2L3.42941 22.2L3.42941 19.8238Z",
    fill: "#1A1B1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9453_135688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 32 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptxIcon);
export default __webpack_public_path__ + "static/media/pptx-icon.debf0afc5730de0910d686effc83fbf8.svg";
export { ForwardRef as ReactComponent };